import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const {
  colors: { ui },
} = constants;
const grey = ui.neutral[500];
const greyDark = ui.neutral[600];
const greyExtraLight = ui.neutral[25];
const { mediaQuery: breakpoint } = mediaQueryStyles;
const { heading4Obj, textXSObj } = typographyStyles;

export const greyLight = ui.neutral[50];

export const cardCss = {
  marginBottom: "20px",
  border: `1px solid ${greyLight}`,

  [breakpoint.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    flexDirection: "row",
    maxHeight: "145px",
    marginBottom: "14px",
  },
};

export const rootCss = {
  position: "relative",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "stretch",
  padding: 0,
  gap: 0,
  overflow: "hidden",
  width: "100%",
  borderRadius: 0,

  [breakpoint.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    flexDirection: "row",
    maxHeight: "145px",
  },
};

export const imageCss = {
  display: "flex",
  maxHeight: "155px",
  objectPosition: "0 0",
  borderRadius: "2px",

  [breakpoint.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    maxWidth: "249px",
    maxHeight: "143px",
  },
};

export const detailsCss = {
  padding: "12px 14px",
  width: "100%",
  textAlign: "left",
  backgroundColor: greyExtraLight,

  h2: {
    ...textXSObj,
    margin: "0",
    color: grey,
    letterSpacing: "1px",
  },

  h3: {
    ...heading4Obj,
    margin: "10px 0",
    color: greyDark,
  },

  p: {
    ...textXSObj,
    margin: 0,
    color: grey,
  },

  [breakpoint.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    padding: "32px 17px",
  },
};

export const formativeIconCss = {
  marginRight: "5px",
  width: "21px",
  height: "21px",
};

export const ctaCss = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  margin: "0",
};

export const printCtaCss = {
  ...ctaCss,
  gap: ".5em",
};

export const externalLinkIconCss = {
  flexShrink: "0",
  width: "17px",
  height: "17px",
  margin: "3px 0 0 5px",

  g: {
    stroke: greyDark,
    strokeWidth: "3px",
  },
};

export const loadingShimmerCss = {
  height: "262px",

  [breakpoint.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    height: "145px",
  },
};
